import { X } from '@phosphor-icons/react'
import PropTypes from 'prop-types'

const OptionsPills = ({ items = [], onRemove, className = '' }) => {
  if (!items || items.length === 0) {
    return null
  }

  const handleRemove = (item) => {
    if (onRemove) {
      onRemove(item)
    }
  }

  return (
    <div className={`options-pills ${className}`}>
      {items.map((item) => (
        <div key={item.id} className="options-pills__pill">
          {item.icon && <item.icon size={14} weight="regular" />}
          <span className="options-pills__text">{item.text}</span>
          <button
            type="button"
            className="options-pills__remove"
            onClick={() => handleRemove(item)}
            aria-label={`Remove ${item.text}`}
          >
            <X size={12} weight="bold" />
          </button>
        </div>
      ))}
    </div>
  )
}

OptionsPills.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      text: PropTypes.string.isRequired,
    }),
  ),
  onRemove: PropTypes.func.isRequired,
  className: PropTypes.string,
}

export default OptionsPills
